import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const config = {
	withCredentials: true,
	headers: { 'Content-Type': 'application/json' },
};

export class SigningServiceApi {
	static sendSingleSigningRequest(params) {
		const url = `${BASE_URL}/sign/invite/preapproved`;
		return axios.post(url, params, config);
	}
	static sendMultipleSigningRequest(params) {
		const url = `${BASE_URL}/sign/invites/preapproved`;
		return axios.post(url, params, config);
	}
	static createDocumentRequest(params) {
		const url = `${BASE_URL}/sign/create/document`;
		return axios.post(url, params, config);
	}
}
